export function getLinkedRequirementCodes(order) {
  const byId = new Map();

  (order?.requirements || []).forEach((req) => {
    if (req?.id) {
      byId.set(req.id, req.code || `REQ-${req.id}`);
    }
  });

  (order?.items || []).forEach((item) => {
    const reqId = item.requirement_item?.requirement_id;
    if (!reqId || byId.has(reqId)) return;
    const code = item.requirement_item?.requirement?.code;
    byId.set(reqId, code || `REQ-${reqId}`);
  });

  return [...byId.values()];
}

export function formatLinkedRequirementCodes(order) {
  return getLinkedRequirementCodes(order).join(', ');
}
